import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '@/context/LanguageContext';

export default function CookiePolicy() {
  const { lang } = useLanguage();

  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Cookie Policy | Officina Martorana</title>
      </Helmet>
      <Navbar />

      <div className="pt-32 pb-20 px-4 sm:px-6 lg:px-8" data-testid="cookie-policy-page">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Space Grotesk' }}>
            Cookie Policy
          </h1>
          <p className="text-sm text-gray-500 mb-12">Ultimo aggiornamento: marzo 2026</p>

          <div className="prose prose-lg max-w-none text-gray-700 space-y-8">

            {/* 1. Cosa sono i cookie */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk' }}>1. Cosa Sono i Cookie</h2>
              <p>
                I cookie sono piccoli file di testo che vengono memorizzati sul dispositivo dell'utente (computer, tablet, smartphone) quando visita un sito web. I cookie consentono al sito di riconoscere il dispositivo dell'utente e di ricordare alcune informazioni sulle sue preferenze o azioni passate.
              </p>
              <p>
                I cookie possono essere "di sessione" (cancellati alla chiusura del browser) o "persistenti" (conservati fino alla loro scadenza o cancellazione manuale). Possono essere impostati dal sito visitato ("cookie di prima parte") o da servizi di terze parti integrati nel sito ("cookie di terze parti").
              </p>
            </section>

            {/* 2. Tipologie di cookie */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk' }}>2. Tipologie di Cookie Utilizzati</h2>

              <h3 className="text-xl font-semibold text-gray-900 mt-6">a) Cookie Tecnici / Necessari</h3>
              <p>
                Questi cookie sono essenziali per il corretto funzionamento del sito e non possono essere disattivati. Garantiscono funzionalità di base come la navigazione tra le pagine, l'accesso alle aree riservate e il funzionamento del sistema di prenotazione.
              </p>
              <div className="overflow-x-auto mt-3">
                <table className="min-w-full border border-gray-200 rounded-xl overflow-hidden not-prose text-sm">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-3 text-left font-semibold text-gray-900 border-b">Cookie</th>
                      <th className="px-4 py-3 text-left font-semibold text-gray-900 border-b">Finalità</th>
                      <th className="px-4 py-3 text-left font-semibold text-gray-900 border-b">Durata</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    <tr><td className="px-4 py-3 font-mono text-xs">lang</td><td className="px-4 py-3">Memorizza la preferenza linguistica dell'utente (IT/EN)</td><td className="px-4 py-3">Persistente</td></tr>
                    <tr><td className="px-4 py-3 font-mono text-xs">token</td><td className="px-4 py-3">Sessione di autenticazione per l'area riservata</td><td className="px-4 py-3">7 giorni</td></tr>
                    <tr><td className="px-4 py-3 font-mono text-xs">cookie_consent</td><td className="px-4 py-3">Registra le preferenze cookie dell'utente</td><td className="px-4 py-3">12 mesi</td></tr>
                  </tbody>
                </table>
              </div>
              <p className="text-sm text-gray-500 mt-2"><em>Base giuridica: non richiedono il consenso dell'utente (Art. 122, co. 1, D.Lgs. 196/2003 e s.m.i.).</em></p>

              <h3 className="text-xl font-semibold text-gray-900 mt-8">b) Cookie Analitici / Di Prestazione</h3>
              <p>
                Questi cookie raccolgono informazioni anonime su come gli utenti utilizzano il sito, consentendo di analizzare il traffico e migliorare l'esperienza di navigazione. I dati sono raccolti in forma aggregata e anonimizzata.
              </p>
              <div className="overflow-x-auto mt-3">
                <table className="min-w-full border border-gray-200 rounded-xl overflow-hidden not-prose text-sm">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-3 text-left font-semibold text-gray-900 border-b">Cookie</th>
                      <th className="px-4 py-3 text-left font-semibold text-gray-900 border-b">Fornitore</th>
                      <th className="px-4 py-3 text-left font-semibold text-gray-900 border-b">Finalità</th>
                      <th className="px-4 py-3 text-left font-semibold text-gray-900 border-b">Durata</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    <tr><td className="px-4 py-3 font-mono text-xs">_ga</td><td className="px-4 py-3">Google Analytics</td><td className="px-4 py-3">Distingue gli utenti unici</td><td className="px-4 py-3">13 mesi</td></tr>
                    <tr><td className="px-4 py-3 font-mono text-xs">_ga_*</td><td className="px-4 py-3">Google Analytics</td><td className="px-4 py-3">Mantiene lo stato della sessione</td><td className="px-4 py-3">13 mesi</td></tr>
                    <tr><td className="px-4 py-3 font-mono text-xs">_gid</td><td className="px-4 py-3">Google Analytics</td><td className="px-4 py-3">Distingue gli utenti</td><td className="px-4 py-3">24 ore</td></tr>
                  </tbody>
                </table>
              </div>
              <p className="text-sm text-gray-500 mt-2"><em>Base giuridica: consenso dell'utente (Art. 6.1.a GDPR). Privacy Policy Google: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#0066b2] hover:underline">policies.google.com/privacy</a></em></p>

              <h3 className="text-xl font-semibold text-gray-900 mt-8">c) Cookie di Profilazione / Marketing</h3>
              <p>
                Questi cookie vengono utilizzati per tracciare l'attività dell'utente sul sito e su altri siti web, al fine di mostrare pubblicità personalizzate e pertinenti. Sono impostati da servizi di terze parti integrati nel sito.
              </p>
              <div className="overflow-x-auto mt-3">
                <table className="min-w-full border border-gray-200 rounded-xl overflow-hidden not-prose text-sm">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-3 text-left font-semibold text-gray-900 border-b">Cookie</th>
                      <th className="px-4 py-3 text-left font-semibold text-gray-900 border-b">Fornitore</th>
                      <th className="px-4 py-3 text-left font-semibold text-gray-900 border-b">Finalità</th>
                      <th className="px-4 py-3 text-left font-semibold text-gray-900 border-b">Durata</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    <tr><td className="px-4 py-3 font-mono text-xs">_fbp</td><td className="px-4 py-3">Meta (Facebook)</td><td className="px-4 py-3">Tracciamento per remarketing Facebook/Instagram</td><td className="px-4 py-3">3 mesi</td></tr>
                    <tr><td className="px-4 py-3 font-mono text-xs">_fbc</td><td className="px-4 py-3">Meta (Facebook)</td><td className="px-4 py-3">Attribuzione click pubblicitari</td><td className="px-4 py-3">3 mesi</td></tr>
                    <tr><td className="px-4 py-3 font-mono text-xs">fr</td><td className="px-4 py-3">Meta (Facebook)</td><td className="px-4 py-3">Pubblicità mirata</td><td className="px-4 py-3">3 mesi</td></tr>
                  </tbody>
                </table>
              </div>
              <p className="text-sm text-gray-500 mt-2"><em>Base giuridica: consenso dell'utente (Art. 6.1.a GDPR). Privacy Policy Meta: <a href="https://www.facebook.com/privacy/policy" target="_blank" rel="noopener noreferrer" className="text-[#0066b2] hover:underline">facebook.com/privacy/policy</a></em></p>
            </section>

            {/* 3. Cookie di terze parti */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk' }}>3. Cookie di Terze Parti</h2>
              <p>Il sito integra servizi di terze parti che possono impostare propri cookie. Di seguito i link alle rispettive informative privacy:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Google (Analytics, Maps, Tag Manager):</strong> <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#0066b2] hover:underline">policies.google.com/privacy</a></li>
                <li><strong>Meta (Facebook, Instagram):</strong> <a href="https://www.facebook.com/privacy/policy" target="_blank" rel="noopener noreferrer" className="text-[#0066b2] hover:underline">facebook.com/privacy/policy</a></li>
                <li><strong>WhatsApp:</strong> <a href="https://www.whatsapp.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#0066b2] hover:underline">whatsapp.com/legal/privacy-policy</a></li>
                <li><strong>X (ex Twitter):</strong> <a href="https://twitter.com/en/privacy" target="_blank" rel="noopener noreferrer" className="text-[#0066b2] hover:underline">twitter.com/en/privacy</a></li>
              </ul>
            </section>

            {/* 4. Banner consenso */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk' }}>4. Banner di Consenso Cookie</h2>
              <p>
                Al primo accesso al sito, l'utente visualizza un banner informativo sui cookie. L'utente può:
              </p>
              <ul className="list-disc pl-6 space-y-1">
                <li><strong>Accettare tutti i cookie:</strong> cliccando su "Accetta tutti", l'utente acconsente all'utilizzo di tutti i cookie descritti in questa policy.</li>
                <li><strong>Rifiutare i cookie non necessari:</strong> cliccando su "Solo necessari", vengono attivati solo i cookie tecnici essenziali.</li>
                <li><strong>Revocare il consenso:</strong> l'utente può modificare le proprie preferenze in qualsiasi momento accedendo al link "Cookie Policy" presente nel footer del sito, oppure cancellando i cookie dal proprio browser.</li>
              </ul>
              <p>
                Il consenso viene memorizzato per un periodo di <strong>12 mesi</strong>, trascorso il quale il banner verrà nuovamente presentato.
              </p>
            </section>

            {/* 5. Disattivazione */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk' }}>5. Come Disattivare i Cookie dal Browser</h2>
              <p>L'utente può gestire e disattivare i cookie direttamente dalle impostazioni del proprio browser. Di seguito le istruzioni per i principali browser:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Google Chrome:</strong> Impostazioni {'>'} Privacy e sicurezza {'>'} Cookie e altri dati dei siti</li>
                <li><strong>Mozilla Firefox:</strong> Impostazioni {'>'} Privacy e sicurezza {'>'} Cookie e dati dei siti web</li>
                <li><strong>Safari:</strong> Preferenze {'>'} Privacy {'>'} Gestisci dati siti web</li>
                <li><strong>Microsoft Edge:</strong> Impostazioni {'>'} Cookie e autorizzazioni sito {'>'} Gestisci ed elimina cookie</li>
              </ul>
              <p className="mt-4">
                <strong>Attenzione:</strong> la disattivazione dei cookie tecnici potrebbe compromettere il corretto funzionamento del sito e impedire l'utilizzo di alcune funzionalità (es. prenotazioni, area riservata).
              </p>
              <p>
                Per un'opzione centralizzata di opt-out dalla pubblicità comportamentale, è possibile visitare: <a href="https://www.youronlinechoices.eu" target="_blank" rel="noopener noreferrer" className="text-[#0066b2] hover:underline">www.youronlinechoices.eu</a>
              </p>
            </section>

            {/* 6. Periodo conservazione */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk' }}>6. Periodo di Conservazione dei Cookie</h2>
              <p>La durata dei cookie varia in base alla tipologia:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li><strong>Cookie tecnici di sessione:</strong> cancellati alla chiusura del browser.</li>
                <li><strong>Cookie tecnici persistenti:</strong> fino a 12 mesi.</li>
                <li><strong>Cookie analitici:</strong> fino a 13 mesi.</li>
                <li><strong>Cookie di marketing:</strong> fino a 3 mesi (Meta) o secondo le policy del fornitore.</li>
              </ul>
              <p className="mt-4">
                L'elenco dei cookie utilizzati è soggetto ad aggiornamento periodico. Si consiglia di consultare questa pagina regolarmente per verificare eventuali variazioni.
              </p>
            </section>

            {/* 7. Collegamento Privacy */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk' }}>7. Collegamento alla Privacy Policy</h2>
              <p>
                Per informazioni complete sul trattamento dei dati personali, si prega di consultare la nostra <Link to="/privacy-policy" className="text-[#0066b2] hover:underline font-medium">Informativa sulla Privacy</Link>.
              </p>
            </section>

            {/* 8. Aggiornamento */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk' }}>8. Modifiche alla Cookie Policy</h2>
              <p>
                Il Titolare si riserva il diritto di modificare la presente Cookie Policy in qualsiasi momento. Le modifiche saranno pubblicate su questa pagina con indicazione della data di ultimo aggiornamento.
              </p>
              <p>
                La presente Cookie Policy è soggetta a revisione annuale o in occasione di modifiche normative o tecnologiche rilevanti.
              </p>
            </section>

          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
